<footer class="copyright">
    <p>
        {{ 'footer.title' | translate }}
        <app-link [link]="link" rel="noopener" target="_blank">{{ 'developedBy.title' | translate }}</app-link>
        {{version}}
    </p>
</footer>
